import { useMutation } from '@tanstack/react-query';
import { resendGiftCardEmail } from '../../services/gift-cards';
import useDeliveryMethods from '../global/useDeliveryMethods';
import { GiftCard } from '../../types/gift-cards';
import { Mediums } from '../../types/global';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: Error) => void | Promise<void>;
}

function useResendGiftCardEmail({ onSuccess, onError }: Options = {}) {
  const getDeliveryMethods = useDeliveryMethods({
    mediums: [Mediums.EMAIL],
  });

  return useMutation({
    mutationFn: async (giftCard: Pick<GiftCard, 'id' | 'customer'>) => {
      if (!giftCard.customer?.user)
        throw new Error('Gift card has no customer');
      const payload = await getDeliveryMethods({
        customer: giftCard.customer.user,
        title: 'Resend gift card',
      });
      const email = giftCard.customer.user.email || payload.email;
      if (!email) {
        throw new Error('Email is required');
      }

      await resendGiftCardEmail({ giftCardId: giftCard.id, email });
    },
    onSuccess,
    onError,
  });
}

export default useResendGiftCardEmail;
